// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__xpUIH","shake":"FloatingButton_shake__94LQT"};